<template>
  <div class="popup-full invite-popup">
    <div class="popup-full__wrap">
      <button type="button"
              class="popup-full__close"
              @click="close">
        <BaseSvg name="ico-close"/>
      </button>

      <div class="popup-full__scroll">
        <div class="popup-full__content">
          <div class="invite-popup__group">
            <h3 class="invite-popup__title">
              {{ $tResumesBaseInviteModal('Invite a candidate') }}
            </h3>
            <!--            <div class="invite-popup__text text">-->
            <!--              <p>{{ $tPartners('invite_employee_text') }}</p>-->
            <!--            </div>-->
            <div class="copy-value">
              <BasePreloader v-if="pending"/>
              <span class="copy-value__val">{{ referralLink }}</span>
              <div class="copy-value__btn-wrap">
                <div class="small-tooltip" :class="{'_show': showCopyTooltip}">
                  <BaseSvg name="ico-check"/>
                  <span>{{ $tResumesBaseInviteModal('Link copied') }}</span>
                </div>
                <button type="button"
                        class="copy-value__btn base-btn base-btn--blue base-btn--small"
                        @click.prevent="onCopy(referralLink)">
                  <BaseSvg name="ico-copy"
                           width="1.2rem"
                           height="1.3rem"/>
                  <span>{{ $tResumesBaseInviteModal('Copy') }}</span>
                </button>
              </div>

            </div>
          </div>

          <div class="invite-popup__group">
            <div class="invite-popup__field _blue">

              <h4 class="invite-popup__field-title">
                {{ $tResumesBaseInviteModal('Phone number') }}
              </h4>
              <div class="invite-popup__field-group">
                <div class="invite-popup__field-label">{{ $tResumesBaseInviteModal('Phone message') }}</div>
                <div class="invite-popup__field-input">
                  <BasePreloader v-if="pendingPhone"/>
                  <BaseInputPhone v-model="phone"
                                  ref="phones"
                                  @validate="phoneObject = $event"
                                  class="_white mt-2 mb-1"/>
                  <div class="invite-popup__field-btn-wrap">
                    <button type="button"
                            :disabled="!isPhoneValid"
                            class="invite-popup__field-btn base-btn base-btn--green base-btn--small"
                            @click.prevent="sendOnPhone">
                      <span>{{ $tResumesBaseInviteModal('Send') }}</span>
                    </button>
                  </div>
                </div>
                <BaseInputError :value="errorPhone"/>
                <BaseAlert :value="messagePhone"
                           class="invite-popup__message  _success"/>
              </div>
            </div>
          </div>
          <div v-if="showFindVacancy" class="invite-popup__group">
            <h4 class="invite-popup__groushowFindVacancyp-title">
              {{ $tResumesBaseInviteModal('Find vacancies title') }}
            </h4>
            <router-link-modified :to="{name: 'find-vacancy-questionnaire'}"
                                  @click.native="close"
                                  class="base-btn  base-btn--outline-blue">
              {{ $tResumesBaseInviteModal('Find vacancies') }}
            </router-link-modified>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {http} from '@/axios'
  import BaseInputError from '../BaseInputError'
  import {blockScroll, unBlockScroll} from '@/helpers/scroll'
  import handleError from '@/helpers/handleError'
  import {AGENT} from '@/constants/usersTypes'

  let timerCopy

  export default {
    name: 'APInvitePopup',
    components: {
      BaseInputError
    },
    props: {
      modalName: {
        type: String,
        default: null,
      },
      showFindVacancy: {
        type: Boolean,
        default: true,
      },
      onSuccessPhoneRequest: {
        type: Function,
        default: () => {},
      },
      //isEmployee: {
      //  type: Boolean,
      //  default: false
      //},
    },
    data() {
      return {
        pending: false,
        // referralLink: null,
        phone: '',
        phoneObject: null,
        pendingPhone: false,
        errorPhone: null,
        messagePhone: null,
        showCopyTooltip: false,
      }
    },
    computed: {
      isPhoneValid() {
        return this.$get(this.phoneObject, 'isValid')
      },
      referralLink() {
        return this.$store.state.user.profile.referal_code
      },
      isAgent() {
        return this.$store.getters['user/userType'] === AGENT
      }
    },
    methods: {
      close() {
        this.$emit('close')
        this.$vModal.close(this.modalName);
      },
      onCopy(text) {
        navigator.clipboard.writeText(text)
        this.showCopyTooltip = true

        clearTimeout(timerCopy)
        timerCopy = setTimeout(() => {
          this.showCopyTooltip = false
        }, 3000)
      },
      sendOnPhone() {
        if (!this.isPhoneValid) return

        this.pendingPhone = true
        this.errorPhone = null
        this.messagePhone = null

        http.post('/api/cabinet/agent/send-invite', {
          phone: this.phone
        }).then(() => {
          this.messagePhone = this.$tResumesBaseInviteModal('Invite sent')
          this.onSuccessPhoneRequest();
        }).catch(e => {
          this.errorPhone = handleError(e)
        }).finally(() => {
          this.pendingPhone = false
        })
      },
    },
    created() {
      blockScroll()
    },
    beforeDestroy() {
      unBlockScroll()
    }
  }
</script>
